import { defineMessages } from "react-intl";

export const messages = defineMessages({
  localDevBannerLabel: {
    id: "rovo-extension.local-dev-banner.label.no-translate",
    defaultMessage: "LOCAL DEV",
    description: "Label for the local dev banner",
  },
});
